<template>
	<div class="add-box">
		<el-dialog v-model="dialogVisible" width="25%" :before-close="handleClose">
			<div class="tongji">
				<el-row>
					<el-col>
						<el-text class="min-size">*注意:</el-text>
						<el-text class="min-size">1. 请上传格式为zip的压缩包，且只能上传zip文件</el-text>
						<el-text class="min-size">2. 压缩包不超过150M(推荐1000张上下)</el-text>
						<el-text class="min-size">3. 请将图片命名方式改为如（姓名_学号.png） 形式</el-text>
					</el-col>
				</el-row>
				
				<el-form-item  prop="" style="margin-top: 15px; height: 35px;">
				    <el-input class="input_view" v-model="filePath"></el-input>
					<el-button :disabled="isDisabled" type="primary" @click="selectFile" style="height: 40px;margin: 10px;">选择文件</el-button>
					<input type="file" style="display: none" ref="fileInput"  accept=".zip" @change="handleFileChange">
				</el-form-item>
				
				<el-form-item v-if="showProgress" label="上传进度:" prop="" style="margin-bottom: 0px;">
					<div v-if="showProgress" class="progress-modal">
						<div class="progress-bar">
							<div :style="{width: progress + '%' }">{{progress}}%</div>
						</div>
					</div>
				</el-form-item>
				<div v-if="showProgress" class="hittext">{{hitText}}</div>
			</div>

			<template #footer>
				<span class="dialog-footer">
					<el-button @click="handleClose">返回</el-button>
					<el-button :disabled="isDisabled" type="primary" @click="zipFileUpload">上传</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	import {
		zipFileUpload
	} from '@/assets/api/renyuan';
	export default {
		props: ['titleValue'],
		components: {},
		data() {
			return {
				dialogVisible: true,
				title: '',
				dialogVisible: true,
				showProgress: false, // 是否显示进度弹窗
				progress: 0,
				isDisabled: false,
				filePath: "",
				file:null,
				hitText:""
			};
		},
		created() {
			this.title = this.titleValue
		},
		mounted() {},
		methods: {
			handleClose() {
				this.$emit('addClick')
			},
			selectFile(event) {
				this.$refs.fileInput.click();
			},

			handleFileChange(event) {
				this.file = event.target.files[0];
				this.filePath = this.file.name
			},
			
			zipFileUpload(){
				this.showProgress = true;
				this.isDisabled = true;
				if (this.file) {
					let formData = new FormData();
					formData.append("file", this.file);
					zipFileUpload(formData, (progress) => {
						this.progress = progress;
						if(this.progress == 100){
							this.hitText ="上传完毕，等候服务器响应请求..."
						}
					}).then((res) => {
						console.log(res);
						this.handleClose()
						this.$message({
							message: '人脸上传成功！',
							type: 'success'
						});
					}).catch((err) => {
						this.$message({
							message: '人脸上传失败！',
							type: 'error'
						});
					})
					event.target.value = '';
				}
			}
		},
	};
</script>

<style scoped lang="scss">
	:deep() {
		.el-dialog__body {
			// height: 75%;
			max-height: 500px;
			// min-height: 350px;        
			overflow: auto;
		}

		.tongji {
			width: 100%;

			.el-col {
				text-align: left;
			}

			.el-text {
				display: block;
				color: white;
			}

			.min-size {
				padding-bottom: 5px;
				font-size: 15px;
				color: #666666;
			}
			
			.hittext{
				margin-top: 5px;
				font-size: 16px;
			}
		}

		.progress-modal {
			position: fixed;
			background-color: rgba(0, 0, 0, 0.5);
			display: flex;
			justify-content: center;
			align-items: center;
			z-index: 999;
		}

		.progress-bar {
			width: 265px;
			height: 10px;
			background-color: #ccc;
			border-radius: 5px;
			font-size: 10px;
		}

		.progress-bar div {
			height: 100%;
			background-color: #007bff;
			text-align: center;
			line-height: 10px;
			color: white;
			border-radius: 5px;
		}

		.input_view{
			height: 30px;
			line-height: 30px;
			width: 250px;
			display: flex;
			flex-wrap: nowrap;
		}
	}
</style>